import React, { useEffect, useState } from "react";
import { fetchReportTasks } from "../../../services/httpClient";
import { formatDateTimeToLocal } from "../../../helpers/date";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface TasksCompletedTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
}

export const TasksCompletedTable = ({
  data,
  startDate,
  endDate,
  useDatePicker = false,
}: TasksCompletedTableState): React.JSX.Element | null => {
  const [taskData, setTaskData] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goal ID", key: "goal_id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "ID", key: "id", hide: true },
    { label: "Task", key: "task_name" },
    { label: "Name", key: "goal_subject.name" },
    { label: "Completed", key: "cm_reviewed_at_formatted" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setTaskData(data);
      } else {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getTaskData(start!, end!);
      }
    };
    fetchData();
  }, [data, startDate, endDate, useDatePicker]);

  const getTaskData = async (start: string, end: string) => {
    fetchReportTasks(start, end)
      .then(async (res: any) => {
        const tasks = res[0].data;
        const sortedTasks = tasks.sort((a: any, b: any) => (a.cm_reviewed_at < b.cm_reviewed_at ? 1 : -1));
        sortedTasks.forEach((task: any) => {
          const localDateTime = formatDateTimeToLocal(task.cm_reviewed_at);
          task.cm_reviewed_at_formatted = localDateTime.date + " " + localDateTime.time;
        });

        setTaskData(sortedTasks);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return taskData ? <DataTable tableHeadings={tableHeaders} tableData={taskData} title={"Tasks Completed"} /> : loadingCard();
};
